/*
 * @Author: 陈朝晖
 * @Date: 2023-06-06 10:07:17
 * @LastEditTime: 2023-06-06 11:15:38
 * @Description:
 */

import axios from "axios";
// 运营模块
const state = {
  data: {},
};

const mutations = {
  setOperate(state, data) {
    state.data = data;
  },
};

const getters = {};

const actions = {
  setOperateAsync({ commit }) {
    axios
      .get("//oss.fjdaze.com/tools/dzPopup/Images/erpOperateConfig.json?_=" + Math.random())
      .then((res) => {
        if (res.data) {
          commit("setOperate", res.data.daze_erp);
        }
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
